
import Vue from 'vue'
import Vuex from 'vuex'

//挂载Vuex
Vue.use(Vuex)

//创建VueX对象
const store = new Vuex.Store({
    state: {
        windonsrc: 'https://lcsy.znhospital.cn/api/sys/file/static/',
        //windonsrc:'https://www.znhospital.com/ywsy/api/sys/file/static/',
       // windonsrc:'http://127.0.0.1:9000/api/sys/file/static/',
        // windonsrc:'https://lcsy.znhospital.cn/api/sys/file/static/',

        windowheight: '',
        dialogImageUrl: "",
        dialogVisibleImg: false,
        menuList: [],
        menumenutype:window.sessionStorage.getItem("menutype")
    },
    mutations: {
        //es6语法，等同edit:funcion(){...}
        setheight(state, height) {
            state.windowheight = height
        }
    }
})
const actions = {
    lookImg(url) {

        for (var i = 0; i < url.length; i++) {
            url[i] = url[i]
        }

        store.state.dialogImageUrl=''
        store.state.dialogImageUrl = url;
        store.state.dialogVisibleImg = true;
    },
}

export default {
    store,
    actions
}



// WEBPACK FOOTER //
// ./src/store/index.js